import { rankWith, scopeEndsWith } from '@jsonforms/core';

export default rankWith(
  2, //increase rank as needed
  scopeEndsWith('textarea')
);
